import React from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { IconButton, List, ListItem, useMediaQuery, useTheme } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import MenuOpenIcon from '@mui/icons-material/MenuOpen'

import logo from '~assets/logo-saf--big.png'
import logoWhite from '~assets/logo-saf--white.png'
import { DrawerProps } from '../../NavigationContainer'
import { useDrawerHeaderOverlayStyles } from './DrawerHeaderOverlay.styles'

const DrawerHeaderOverlay: React.FC<DrawerProps> = (props) => {
  const { drawerLarge, drawerOpen, useHoverDrawer, toggleDrawerLarge, toggleDrawerOpen, isMobile } = props
  const s = useDrawerHeaderOverlayStyles()
  const { t } = useTranslation()

  return <List
    className={clsx(s.menuOverlay,
      isMobile && s.menuOverlayHeightMobile,
      !useHoverDrawer && !drawerLarge && s.menuOverlaySmall,
      !useHoverDrawer && drawerLarge && s.menuOverlayLarge,
      useHoverDrawer && s.menuOverlaySmall,
    )}
    style={{ position: 'fixed', top: 0 }}
  >
    <ListItem
      className={clsx(s.menuOverlayItem, s.menuOverlayItemLeft,
        !useHoverDrawer && !drawerLarge && s.menuOverlayItemSmall,
        !useHoverDrawer && drawerLarge && s.menuOverlayItemLarge,
        useHoverDrawer && s.menuOverlayItemSmall,
      )}
    >
      <IconButton
        color='default' aria-label='open drawer' edge='start'
        className={s.iconStackContainer}
        onClick={() => {
          toggleDrawerOpen()
          toggleDrawerLarge()
        }}
      >
        <MenuIcon
          className={clsx(s.menuIcon,
            !useHoverDrawer && drawerLarge && s.elementHidden,
            useHoverDrawer && drawerOpen && s.elementHidden,
            useHoverDrawer && !drawerOpen && s.whiteIcon,
          )}
        />
        <MenuOpenIcon
          className={clsx(s.menuIcon, s.stackedIcon,
            !useHoverDrawer && !drawerLarge && s.elementHidden,
            useHoverDrawer && !drawerOpen && s.elementHidden,
          )}
          color={isMobile ? 'secondary' : 'inherit'}
        />
      </IconButton>
    </ListItem>
    <ListItem
      className={clsx(s.menuOverlayItem, s.menuOverlayItemRight,
        !useHoverDrawer && !drawerLarge && s.menuOverlayItemSmall,
        useHoverDrawer && s.menuOverlayItemSmall,

        // useHoverDrawer && isMobile && s.menuOverlayItemSmall,
        // { backgroundColor: 'red' },
      )}
    >
      <div className={s.siteLogoContainer}>
        <img
          className={clsx(s.siteLogo,
            !useHoverDrawer && drawerLarge && s.elementHidden,
            !useHoverDrawer && drawerLarge && s.siteLogoRight,
            useHoverDrawer && drawerOpen && s.elementHidden,
          )}
          src={logoWhite}
          alt={t('common:logoAlt')}
        />
        <img
          className={clsx(s.siteLogo,
            !useHoverDrawer && !drawerLarge && s.elementHidden,
            !useHoverDrawer && drawerLarge && s.siteLogoRight,
            useHoverDrawer && !drawerOpen && s.elementHidden,
          )}
          src={logo}
          alt={t('common:logoAlt')}
        />
      </div>
    </ListItem>
  </List>
}

export default DrawerHeaderOverlay
